import { render, staticRenderFns } from "./weekDayCrud.vue?vue&type=template&id=2c5b3987"
import script from "./weekDayCrud.vue?vue&type=script&lang=js"
export * from "./weekDayCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports